import React from 'react';
import {
  Drawer,
  DrawerOverlay,
  DrawerContent,
  DrawerCloseButton,
  DrawerHeader,
  DrawerBody,
  DrawerFooter,
  Spinner,
  Flex,
  Text,
  Box,
} from '@chakra-ui/react';

export const DetailItem = ({ label, value }) => (
  <Box>
    <Text fontSize="xs" color="gray.500" mb={0.5}>
      {label}
    </Text>
    <Text fontSize="sm" fontWeight="medium">
      {value ?? '—'}
    </Text>
  </Box>
);

const AppointmentEntityDrawer = ({
  isOpen,
  onClose,
  title,
  loading,
  children,
  footer,
}) => (
  <Drawer isOpen={isOpen} placement="right" onClose={onClose} size="md" closeOnOverlayClick={false}>
    <DrawerOverlay />
    <DrawerContent>
      <DrawerCloseButton />
      <DrawerHeader borderBottomWidth="1px">{title}</DrawerHeader>
      <DrawerBody py={4}>
        {loading ? (
          <Flex justify="center" py={12}>
            <Spinner />
          </Flex>
        ) : (
          children
        )}
      </DrawerBody>
      {footer && <DrawerFooter borderTopWidth="1px">{footer}</DrawerFooter>}
    </DrawerContent>
  </Drawer>
);

export default AppointmentEntityDrawer;
